import ReactMarkdown, { Components } from 'react-markdown';
import remarkBreaks from 'remark-breaks';

import { Linkify } from '@/components/shared/components/Linkify';

const ALLOWED_ELEMENTS = ['p', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'br', 'code'];

// linkify-react recurses into every child of whatever it wraps, including the props of custom
// (non-DOM) components -- wrapping the whole <ReactMarkdown> tree in <Linkify> corrupts its
// `children` prop before react-markdown ever renders. Applying Linkify per leaf block (p, li)
// instead means it only ever sees already-rendered DOM elements (p, strong, em, a, text), which is
// what it's designed to walk.
const components: Components = {
    p: ({ children }) => (
        <p>
            <Linkify ignoreTags={['a']}>{children}</Linkify>
        </p>
    ),
    li: ({ children }) => (
        <li>
            <Linkify ignoreTags={['a']}>{children}</Linkify>
        </li>
    ),
};

interface FormattedTextProps {
    children: string;
    /** Defaults to true so single line breaks render as hard breaks, matching how notes are typed. Set false to let markdown collapse them into flowing text. */
    breaks?: boolean;
}

export const FormattedText = ({ children, breaks = true }: FormattedTextProps) => {
    if (!children) return null;

    return (
        <ReactMarkdown
            remarkPlugins={breaks ? [remarkBreaks] : []}
            allowedElements={ALLOWED_ELEMENTS}
            unwrapDisallowed
            components={components}
        >
            {children}
        </ReactMarkdown>
    );
};
